import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute } from "@angular/router";
import { BookingService } from "../../../shared/services/booking.service";
@Component({
  selector: 'app-success-payment',
  templateUrl: './success-payment.component.html',
  styleUrls: ['./success-payment.component.scss']
})
export class SuccessPaymentComponent implements OnInit {
  code: any;
  customerData = [];
  isLoading=false;
  constructor(
    public router: Router,
    public ActivatedRoute: ActivatedRoute,
    public bookingService: BookingService,
  ) {

  }


  ngOnInit(): void {
    this.ActivatedRoute.queryParams
      .subscribe(params => {
        this.code = params.code
      }
      );

    if (this.code) {
      this.getCustomerData(this.code);
    }
  }

  getCustomerData(code) {
    this.bookingService.getOrderDetails(code).subscribe({
      next: (response: any) => {
        this.isLoading=false;
        this.customerData = response?.data;
      },
      error: (error) => {
        this.isLoading=false;
      }
    });
  }

  tConvert(time){
    // Check correct time format and split into components
    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
      time = time.slice (1);  // Remove full string match value
      time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join (''); // return adjusted time or original string
  }
}
